import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

const RedirectHomePage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/', { state: { resetHistoryLevel: 0 } });
  }, []);

  return <br />;
};

export default RedirectHomePage;
